// src/components/Attendance.js
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import StudentAttendance from './StudentAttendance';
import { useGrade } from '../../../context/GradeContext';
import Form from 'react-bootstrap/Form';
import DailyAttendanceModal from '../Modals/DailyAttendanceModal';
import { useARData } from '../../../context/AttendanceRecordContext';
import { filterStudentsByClass } from '../Utility/filterStudentsByClass';  // Make sure this import path is correct

const Attendance = () => {
    // for daily attendance modal
    const daModal = useRef();

    // get classes from database
    const { grade } = useGrade();

    // this is the attendance data context 
    const { arData } = useARData();

    // for selective display of records
    const [selectedGrade, setSelectedGrade] = useState('--Select--');

    const selectOption = (e) => {
        setSelectedGrade(e.target.value);
    }

    // Filter the attendance data based on the selected grade
    const filteredData = selectedGrade === '--Select--' ? arData : filterStudentsByClass(arData, selectedGrade);



    return (
        <>        
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title flex-wrap">
                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" placeholder="Search here..." />
                                    <span className="input-group-text">
                                        <Link to={"#"}>
                                            <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF"/>
                                            </svg>
                                        </Link>
                                    </span>
                                </div>
                                <div className='d-flex'>
                                    <Form.Select size="sm" style={{width:'120px'}} value={selectedGrade} onChange={selectOption}>
                                        {grade.map((item, index) => 
                                            <option value={item.class_options} key={index}>{item.class_label}</option>
                                        )}
                                    </Form.Select>
                                    <span className="p-2"></span>                                                                   
                                    <button type="button" className="btn btn-primary" onClick={() => daModal.current.openModal()}>
                                        + Daily Attendance
                                    </button>
                                    <span className='p-2'></span>
                                    <button className='btn btn-success'>
                                        Bulk Record
                                    </button>
                                </div>
                            </div>
                        </div>                
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data">
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <StudentAttendance data={filteredData} />
                                </div>
                            </div>  
                        </div>    
                    </div>    
                </div>    
            </div>   
            <DailyAttendanceModal ref={daModal} />
        </>
    )
}

export default Attendance;
